<script lang="ts">
  import { onMount } from "svelte";
  import { Col, Container, Row, Button } from "sveltestrap";
  import { Form, FormGroup, FormText, Input, Label } from "sveltestrap";
  import { Route } from "svelte-router-spa";

  import Spacer from "@/components/spacer.svelte";

  import MAP from "@/components/map.svelte";

  export let currentRoute;
  export let params = {};

  var backup_html;
  var is_send = 0;

  async function postData() {
    backup_html = document.getElementsByClassName("contact-wrap")[0].innerHTML;
    document.getElementsByClassName("contact-wrap")[0].innerHTML =
      "<div>문의를 접수하는 중입니다.</div>";
    var c_type = document.getElementsByClassName("form-select")[0].value;
    var c_name = document.getElementById("name").value;
    var c_email = document.getElementById("email").value;
    var c_phone = document.getElementById("phone").value;
    var c_detail = document.getElementById("detail").value;

    // 옵션 기본 값은 *로 강조
    const response = await fetch(
      "https://script.google.com/macros/s/AKfycbyLEZNRAmOQwXifWQrF_d4_dj5fpfpBKyGejAGzNSjKPtl4JM602uuFmfiTzWv7PZ38Hg/exec",
      {
        method: "POST", // *GET, POST, PUT, DELETE 등
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          type: c_type,
          name: c_name,
          email: c_email,
          phone: c_phone,
          detail: c_detail,
        }),
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      }
    );
    return response.json();
    // isSend=0;
    //$(".submit-wrap").html(back_wrap);
  }

  function submitForm(event) {
    event.preventDefault();
    if (is_send == 1) return false;
    is_send = 1;

    postData()
      .then((data) => {
        if (data.code == "success") {
          alert(data.msg);
          location.reload();
        } else {
          alert(data.msg);
        }
      })
      .catch((error) => {
        alert("문제가 발생했습니다. 다시 시도해주세요.");
        is_send = 0;
        document.getElementsByClassName("contact-wrap")[0].innerHTML =
          backup_html;
      });
  }
</script>

<Spacer size="116px" />
<div class="background" />
<div id="wrap" class="clearfix">
  <div class="wrap80">
    <div class="wrap80_2">
      <div class="contact1">
        <div class="contactfont">contact us</div>
        <Spacer size="2rem" />
        <div class="infowrap">
          <img
            class="infoimg"
            src="/images/contact/icon_map.png"
            alt="지도 아이콘"
          />
          <div style="margin-top: 0.5rem;line-height: 19px;">
            경기도 부천시 부흥로 303번길 36<br />(중동, 금호프라자 507호)
          </div>
        </div>
        <div class="infoonewrap" style="min-height: 45px;">
          <div>
            <img
              class="infoimg"
              src="/images/contact/icon_call.png"
              style="padding-top: 2px;"
              alt="전화 아이콘"
            />
          </div>
          <div style="padding-top: 0.6rem; margin-top: 0.3rem;">
            032-662-5000
          </div>
        </div>
        <div class="infoonewrap" style="min-height: 45px;">
          <div>
            <img
              class="infoimg"
              src="/images/contact/icon_email.png"
              style="padding-top: 2px;"
              alt="이메일 아이콘"
            />
          </div>
          <div style="padding-top: 0.6rem; margin-top: 0.3rem;">
            nare@naretrends.com
          </div>
        </div>
        <Spacer size="2rem" />
        <div class="infoonewrap" style="margin-bottom:0.8rem;">
          <a
            href="https://www.facebook.com/%EB%B0%98%EB%94%A7%EB%B6%88%EC%9D%B4-104368752227553/?ref=page_internal"
            target="_blank"
          >
            <img
              src="/images/contact/icon_facebook.png"
              alt="페이스북 아이콘"
            />
          </a>
          <a
            href="https://www.youtube.com/channel/UCXv6HaUZw4u0ydciriHQk-Q"
            target="_blank"
          >
            <img
              src="/images/contact/icon_youtube.png"
              style="margin-left: 4px;"
              alt="유튜브 아이콘"
            />
          </a>
          <a href="https://blog.naver.com/dper2000" target="_blank">
            <img
              src="/images/contact/icon_blog.png"
              style="margin-left: 4px;"
              alt="블로그 아이콘"
            />
          </a>
        </div>
        <Spacer size="0.3rem" />
        <MAP />
      </div>
      <div class="contact2">
        <form id="sendMail" on:submit|preventDefault={submitForm}>
          <FormGroup>
            <Label for="type">문의유형*</Label>
            <Input
              type="select"
              name="type"
              id="type"
              style="width: 80%;"
              required
            >
              <option value="">문의 유형을 선택해주세요.</option>
              <option value="스마트팜 설치">스마트팜 설치</option>
              <option value="교육, 컨설팅">교육, 컨설팅</option>
              <option value="투자관련">투자관련</option>
              <option value="관리시스템 및 사용방법"
                >관리시스템 및 사용방법</option
              >
              <option value="기타">기타</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="name">성함 (업체명)*</Label>
            <Input
              type="text"
              name="name"
              id="name"
              placeholder="성함이나 업체명을 입력해주세요."
              style="width: 80%;"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="email">이메일 주소</Label>
            <Input
              type="email"
              name="email"
              id="email"
              placeholder="이메일 주소를 입력해주세요."
              style="width: 80%;"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="phone">연락처*</Label>
            <Input
              type="text"
              name="phone"
              id="phone"
              placeholder="휴대폰 번호를 입력해주세요."
              style="width: 80%;"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="detail">문의사항</Label>
            <Input
              type="textarea"
              name="detail"
              id="detail"
              placeholder="문의사항을 입력해주세요."
              style="width: 80%; height: 180px"
              required
            />
            <div class="contact-wrap">
              <Button type="submit" style="background: #5c3427;"
                >문의하기</Button
              >
            </div>
          </FormGroup>
        </form>
      </div>
    </div>
  </div>

  <Spacer size="5rem" />
</div>

<Route {currentRoute} {params} />

<style lang="scss">
  .clearfix::after {
    display: table;
    content: "";
    clear: both;
  }
  #wrap {
    margin: 0 auto;
    position: relative;
    color: #5c3327;
  }
  .background {
    position: absolute;
    background-image: url("/images/contact/contact_bg.jpg");
    background-size: 100% 161%;
    width: 100%;
    height: 53%;
  }

  .contact1 {
    float: none;
    width: 80%;
    margin-right: 0px;
    margin-left: 10%;
    margin-top: 30px;
  }
  .contact2 {
    float: none;
    width: 80%;
    margin-left: 17%;
    margin-top: 45px;
  }
  .wrap80 {
    width: 90%;
    display: block;
    margin: 0 auto;
  }
  .wrap80_2 {
    display: inline-block;
    margin-left: 0px;
    width: 100%;
    border-radius: 30px;
    background-color: #fff;
    box-sizing: border-box;
    box-shadow: 0px 8px 25px #6d6d6d;
    margin-top: 1.5rem;
  }
  @media (min-width: 768px) {
    .contact1 {
      float: left;
      width: 35%;
      margin-right: 0px;
      margin-left: 10%;
      margin-top: 30px;
    }
    .contact2 {
      float: right;
      width: 45%;
      margin-right: 0px;
      margin-left: 0px;
      margin-top: 45px;
    }
    .wrap80 {
      width: 80%;
      display: block;
      margin: 0 auto;
    }
    .wrap80_2 {
      display: inline-block;
      margin-left: 10%;
      width: 80%;
      border-radius: 30px;
      background-color: #fff;
      box-sizing: border-box;
      box-shadow: 0px 8px 25px #6d6d6d;
      margin-top: 1.5rem;
    }
  }
  .contact-wrap {
    text-align: center;
    width: 80%;
    height: 60px;
    line-height: 60px;
    margin-top: 5px;
  }
  .contactfont {
    font-weight: bold;
    color: #5c3327;
    font-size: 2.5rem;
    line-height: 3rem;
  }
  .infowrap {
    font-size: 0.9rem;
    display: block;
    min-height: 45px;
  }
  .infoonewrap {
    font-size: 0.9rem;
    display: block;
  }
  .infoonewrap > a > img {
    width: 28px;
  }
  .infoimg {
    width: 36px;
    margin-right: 13px;
    display: inline-block;
    float: left;
  }
</style>
